import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Link from "shared/components/Link";
import Str from "shared/components/Str";
import isSpa from "shared/util/isSpa";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";

const NavBarLink = ({ isSelected, IconComponent, text, path }) => (
	<Link
		to={path}
		className="navbar-link"
		onClick={() => {
			selectedOptionOnNavBarEvent(text);
		}}
		noSpa={!isSpa()}
	>
		<div className="navbar-link-icon-container" >
			<IconComponent
				className={classnames("navbar-icon", {
					"navbar-icon-selected": isSelected,
				})}
				width={24}
				height={24}
			/>
			<div
				className={classnames("navbar-underline", {
					"navbar-underline-selected": isSelected,
				})}
			/>
		</div>
		<span className="navbar-text">
			<Str>{text}</Str>
		</span>
	</Link>
);

NavBarLink.defaultProps = {
	isSelected: false,
};

NavBarLink.propTypes = {
	isSelected: PropTypes.bool,
	IconComponent: PropTypes.func.isRequired,
	text: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
};

export default NavBarLink;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/NavBarLink.jsx